import { fetchEntities } from 'actions/entities'
import SchemaForm from 'components/forms/SchemaForm'

import dotProp from 'dot-prop'

import dossierSchema from 'forms/dossierSchema'
import React from 'react'
import { connect } from 'react-redux'
import { getCurrentOffice } from "../../selectors/offices";

class DossierForm extends React.Component {
  componentDidMount() {
    this.props.fetchEntities()
  }

  render() {
    return (
      <SchemaForm entityName='dossier' {...this.props}/>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let office = getCurrentOffice(state)
  let showDossierNumber = office.hiddenPreferences && office.hiddenPreferences.includes("showDossierNumber")

  return {
    uiSchema: dossierSchema(state, ownProps, showDossierNumber),
    invoiceReceiver: dotProp.get(state, `entities.dossier.byId.${ownProps.entityId}.invoiceReceiver`)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchEntities: () => {
      dispatch(fetchEntities('employments'))
      dispatch(fetchEntities('locations'))
      dispatch(fetchEntities('countries'))
      dispatch(fetchEntities('contacts'))
      dispatch(fetchEntities('organisations'))
      dispatch(fetchEntities('healthFunds'))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DossierForm);
